/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature7Inputs */

const ja_playdata_pricing_feature7 = /** @type {(inputs: Playdata_Pricing_Feature7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム別競合分析`)
};

const en_playdata_pricing_feature7 = /** @type {(inputs: Playdata_Pricing_Feature7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive analysis by game`)
};

/**
* | output |
* | --- |
* | "Competitive analysis by game" |
*
* @param {Playdata_Pricing_Feature7Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature7 = /** @type {((inputs?: Playdata_Pricing_Feature7Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature7Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature7(inputs)
	return en_playdata_pricing_feature7(inputs)
});